export default function CardDollarIcon() {
  return (
    <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.35623 8.21025C7.72649 7.78666 7.20239 7.34871 7.20239 6.66666C7.20239 5.88409 7.92752 5.33845 9.14085 5.33845C10.4188 5.33845 10.8926 5.94871 10.9357 6.84614H12.5224C12.4721 5.61127 11.7183 4.47691 10.2178 4.11076V2.53845H8.06393V4.08922C6.67111 4.39076 5.55111 5.29538 5.55111 6.68102C5.55111 8.33948 6.92239 9.16512 8.92546 9.64614C10.7203 10.0769 11.0793 10.7087 11.0793 11.3764C11.0793 11.8718 10.7275 12.6615 9.14085 12.6615C7.66188 12.6615 7.08034 12.001 7.00136 11.1538H5.42188C5.50803 12.7261 6.68546 13.6092 8.06393 13.9036V15.4615H10.2178V13.9179C11.6178 13.6523 12.7306 12.841 12.7306 11.3692C12.7306 9.33025 10.986 8.63384 9.35623 8.21025Z'
        fill='currentColor'
      />
    </svg>
  );
}
